import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { withStyles, Button, Typography } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import CloudDoneIcon from '@material-ui/icons/CloudDone'

const styles = theme => ({
  btn: {
    marginRight: theme.spacing(1),
    width: '100%'
  }
})

const MyDropzone = ({
  input,
  classes,
  accept,
  label,
  fetching,
  onFileChange,
  showError,
  ...rest
}) => {
  const [file, setFile] = useState()
  const [message, setMessage] = useState(null)

  const onDrop = useCallback(
    async acceptedFiles => {
      const [file] = acceptedFiles
      if (file) {
        setFile(file)
        setMessage(null)
        if (onFileChange) {
          onFileChange(file.name)
        }
        input.onChange(file)
      } else {
        setFile(null)
        setMessage('Arquivo inválido')
      }
    },
    [input, onFileChange]
  )

  useEffect(() => {
    setFile(input.value)
  }, [input.value])

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    noDrag: true
  })
  return (
    <>
      <div {...getRootProps()}>
        <input {...getInputProps()} {...rest} />
        <Button
          variant="outlined"
          color="secondary"
          disabled={fetching}
          className={classes.btn}
          startIcon={file ? <CloudDoneIcon /> : <CloudUploadIcon />}
        >
          {label || 'Selecionar arquivo'}
        </Button>
        <Typography variant="caption">
          {accept ? `Formatos: ${accept}` : ''}
        </Typography>
        <Typography variant="caption" component="span" color="error">
          {message}
          <br />
          {(showError || rest.meta.touched) && !file && rest.meta.error}
        </Typography>
      </div>
    </>
  )
}

export default withStyles(styles)(MyDropzone)
